import { Routes } from "@/lib/routes"
import { Resources } from "../categoryPanel"
import { ResourceTemplateCard } from "./ResourceTemplateCard"
import { ResourceLibraryCard } from "./ResourceLibraryCard"
import { ResourceIndustryCard } from "./ResourceIndustryCard"
import CalculatorCard from "@/components/calculators/CalculatorCard"
import { ResourceType } from "@/app/generated/prisma"

export function ResourceCard({ item, type }: { item: Resources; type: ResourceType }) {
   const hrefLink = Routes.client.resourceDownloadPage.getPath({
      resourceType: type,
      // categorySlug: generateSlug(item.category?.name ?? ""),
      resourceSlug: item.slug,
   })

   const ariaLabel =
      type === ResourceType.library
         ? `Download ${item.title} resource`
         : type === ResourceType.industry_trends
           ? `Read ${item.title} industry report`
           : `Download ${item.title} template`

   return ResourceCardComponent(type, item, hrefLink, ariaLabel)
}

const ResourceCardComponent = (type: ResourceType, item: Resources, hrefLink: string, ariaLabel: string) => {
   switch (type) {
      case ResourceType.tools:
         return (
            <CalculatorCard
               title={item.title}
               description={item.description ?? ""}
               imageSrc={item.image || "/_images/resources/default-calculator.png"}
               href={hrefLink}
               categoryName={item.category?.name}
            />
         )
      case ResourceType.library:
         return <ResourceLibraryCard item={item} href={hrefLink} ariaLabel={ariaLabel} />
      case ResourceType.templates:
         return <ResourceTemplateCard item={item} href={hrefLink} ariaLabel={ariaLabel} />
      case ResourceType.industry_trends:
         return <ResourceIndustryCard item={item} href={hrefLink} ariaLabel={ariaLabel} />
      default:
         return null
   }
}
